import axios from './../http'


function add(data) {
    return axios.post('/sys/register/add', data);
}

function sendEmail(data) {
    return axios.post('/sys/register/sendEmail', data);
}



export default {
    add,
    sendEmail
}